module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/fantasy-invest/2.png?f6f2e04a48781591052f1f38d2834110";